import { Box, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { routeLocationsEnum } from "../../Router/Router";
import {
  headerStyles,
  navigateItemStyles,
  searchContainerStyles,
  selectStyles,
} from "./styles";
import { useTranslation } from "react-i18next";
import i18n from "../../utils/i18n";
import { useEffect } from "react";
import { useAppDispatch } from "../../store/store";
import { setCemeteryTitlesToStore } from "../../store/reducers/CemeteryReducer/actions";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const handleNavigate = (path: string) => {
    const targetPath =
      path === routeLocationsEnum.cemeteryList
        ? i18n.language
        : `${i18n.language}${path}`;
    navigate(targetPath);
  };

  const changeLanguage = (e: SelectChangeEvent<string>) => {
    const selectedLanguage = e.target.value;
    const targetPath = window.location.pathname.replace(
      `/${i18n.language}`,
      `/${selectedLanguage}`
    );
    i18n.changeLanguage(selectedLanguage);
    navigate(targetPath);
  };

  const translations = i18n.t("header", { returnObjects: true }) as {
    [key: string]: string;
  };
  useEffect(() => {
    const pathSegments = window.location.pathname.split("/");
    const languageInUrl = pathSegments[1];
    if (languageInUrl && i18n.language !== languageInUrl) {
      i18n.changeLanguage(languageInUrl);
    }
  }, []);

  return (
    <Box sx={headerStyles}>
      <Box sx={searchContainerStyles}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "25px",
          }}
        >
          <Box sx={{ width: "5.5rem", height: "5rem" }}>
            <img
              src={"https://smerli.lv/img/logo.png"}
              onClick={() => handleNavigate(routeLocationsEnum.cemeteryList)}
              style={{ cursor: "pointer", width: "100%", height: "100%" }}
              alt="header logo"
            />
          </Box>
          <Box
            onClick={() => handleNavigate(routeLocationsEnum.cemeteryList)}
            sx={navigateItemStyles}
          >
            {t(translations.cemeteryList)}
          </Box>
          <Box
           onClick={() => {
            handleNavigate(routeLocationsEnum.personSearch);
            dispatch(setCemeteryTitlesToStore());
          }}
          
            sx={navigateItemStyles}
          >
            {t(translations.searchForDeceased)}
          </Box>
        </Box>
        <Box>
          <Select
            value={i18n.language}
            onChange={changeLanguage}
            displayEmpty
            defaultValue="en"
            sx={selectStyles}
          >
            <MenuItem value="en"> {t(translations.english)}</MenuItem>
            <MenuItem value="ru">{t(translations.russian)}</MenuItem>
            <MenuItem value="lv">{t(translations.latvian)}</MenuItem>
          </Select>
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
